import { combineReducers } from 'redux';

import ibge from './ibge/combineReducers';
import municipio from './municipio/combineReducers';

export default combineReducers({
	ibge,
	municipio,
});
